import * as React from 'react'
import PropTypes from 'prop-types'
import * as ProgressSteps  from 'react-progress-steps';
import { withRouter } from 'react-router-dom';
import WizardFormFirstPage from './WizardFormFirstPage'
import WizardFormSecondPage from './WizardFormSecondPage'
import { database } from '../../firebase';
import OnboardingSteps from '../Steps';
import { connect } from 'react-redux';
import { createAction, handleActions } from 'redux-actions';

export const onboardingCompleteAction = createAction('@DONACO/ONBOARDING_COMPLETE'); // TODO find out why the enum definition wasn't working and refactor

const usersRef = database.ref('users');

class WizardFormComponent extends React.Component<any> {
  constructor(props) {
    super(props);

    this.charitiesRef = database.ref('/charities');

    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      page: 1
    }
  }
  nextPage() {
    this.setState({page: this.state.page + 1})
  }

  previousPage() {
    this.setState({page: this.state.page - 1})
  }

  handleSubmit(values: any) {
    const { onboardingComplete, auth } = this.props;
    const { name, charityId, description, displayName, role, phone } = values;

    const newCharity: any = {
      name,
      charityId,
      description,
      timestamp: new Date().toISOString(),
    };

    const newUser: any = {
      displayName,
      role,
      phone,
      onboardingComplete: true,
      email: auth.email
    };
    const { history } = this.props;

    this.charitiesRef.push(newCharity).then((charitySnapshot) => {
        // Link the user to the charity they just created
        const charityKey = charitySnapshot.key;
        newUser.charityKey = charityKey;

        usersRef.child(auth.uid).once('value', function(snapshot) {
          const userData = snapshot.val();
          usersRef
          .child(auth.uid)
          .set({ ...userData, ...newUser})
          .then(() => {
            onboardingComplete();
            if (!!history) {
              history.push('/payments');
              // TODO destroy props here?
            }
          })
        });
        
    });
  }

  render() {
    const {page} = this.state;
    return (
      <div>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <div className="onboarding-steps">
            <OnboardingSteps current={page} />
          </div>
          <div style={{width: '75%', alignSelf: 'center'}}>
            {page === 1 && <WizardFormFirstPage onSubmit={this.nextPage} />}
            {page === 2 &&
              <WizardFormSecondPage
                previousPage={this.previousPage}
                onSubmit={this.handleSubmit}
              />}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch) => ({
  onboardingComplete: () => dispatch(onboardingCompleteAction())
});

const WizardForm = connect(mapStateToProps, mapDispatchToProps)(WizardFormComponent);

// WizardForm.propTypes = {
//   onSubmit: PropTypes.func.isRequired
// }

export default withRouter(WizardForm)
